import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const pains = ['Corrés todo el partido pero llegás siempre tarde a las coberturas.', 'Recibís de espaldas, te apuran y terminás devolviendo al central sin progresar.', 'No sabés si jugar de primera, conducir o cambiar de frente y dudás siempre.', 'Terminás cada partido fundido y con la sensación de que no rendiste.'];
export function Pains() {
  return <section className="py-12 px-4 bg-brand-surface border-y border-brand-border" data-id="element-85">
      <div className="max-w-4xl mx-auto" data-id="element-86">
        <div className="text-center mb-8" data-id="element-87">
          <h2 className="font-display text-3xl md:text-5xl tracking-wide text-brand-text leading-tight" data-id="element-88">
            ¿TE PASA QUE JUGÁS DE 5 PERO{' '}
            <span className="text-brand-green" data-id="element-89">NO JUGÁS COMO UN 5</span>?
          </h2>
          <p className="text-brand-muted mt-3 text-base md:text-lg" data-id="element-90">
            Estos problemas se repiten partido tras partido — y tienen solución.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-91">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: index * 0.07
        }} className="bg-white border border-brand-border rounded-lg p-4 flex items-start gap-3 hover:border-brand-green/40 transition-colors" data-id="element-92">
              <div className="flex-shrink-0 w-7 h-7 rounded-full bg-red-50 flex items-center justify-center text-red-500 mt-0.5" data-id="element-93">
                <X className="w-4 h-4" strokeWidth={3} data-id="element-94" />
              </div>
              <p className="text-brand-text text-sm md:text-base leading-snug font-medium" data-id="element-95">
                {pain}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}